import React from 'react';

import { ApolloProvider } from '@apollo/client';

import { client } from './client';

/**
 * The root for setting up the GraphQL Provider to use [[useGraphQLQuery]]
 * The bare minimum setup using the default configuration:
 * ```typescript
 *
 * // within return statement of a component
 * <GraphQLProvider>
 *   // components depending on useQuery or useMutation
 * </GraphQLProvider>
 * ```
 */
export const GraphQLProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
